import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "cowpelt";

function GICowPelt() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GICowPelt;